var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.$route.params.id
            ? _vm.isDisabled
              ? "商品详情"
              : "编辑商品"
            : "添加商品",
          backUrl: _vm.pageTitleBack,
        },
      }),
      _vm.$route.params.isCopy
        ? _c(
            "el-card",
            {
              staticClass: "mt14",
              attrs: { shadow: "never", bordered: false },
            },
            [
              _c("div", { staticClass: "line-ht mb15" }, [
                _vm._v(" 生成的商品默认是没有上架的，请手动上架商品！ "),
                _vm.copyConfig.copyType && _vm.copyConfig.copyType == 1
                  ? _c("span", [
                      _vm._v(
                        "您当前剩余" +
                          _vm._s(_vm.copyConfig.copyNum) +
                          "条采集次数。 "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "tips-bottom" }, [
                  _vm._v(
                    " 商品采集设置：设置 > 系统设置 > 第三方接口设置 > 采集商品配置（如配置一号通采集，请先登录一号通账号，无一号通，请选择99Api设置） "
                  ),
                ]),
              ]),
              _vm.copyConfig.copyType
                ? _c(
                    "div",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth100",
                          attrs: {
                            placeholder: "请输入链接地址",
                            size: "small",
                          },
                          model: {
                            value: _vm.url,
                            callback: function ($$v) {
                              _vm.url =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "url",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.addProduct },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              on: { "tab-click": _vm.tabsHandleClick },
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "商品信息", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "规格库存", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "商品详情", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "其他设置", name: "3" } }),
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 0,
                      expression: "currentTab == 0",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：", prop: "storeName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "249",
                              placeholder: "请输入商品名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "storeName", $$v)
                              },
                              expression: "formValidate.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：", prop: "cateIds" } },
                        [
                          _c("el-cascader", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props2,
                              clearable: "",
                              "show-all-levels": false,
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.cateIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "cateIds", $$v)
                              },
                              expression: "formValidate.cateIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品关键字：", prop: "keyword" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入商品关键字",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.keyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "keyword", $$v)
                              },
                              expression: "formValidate.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位：", prop: "unitName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入单位",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.unitName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "unitName", $$v)
                              },
                              expression: "formValidate.unitName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品封面图：", prop: "image" } },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row upLoadPicBox row-middle" },
                            [
                              _vm.formValidate.image
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pictrue",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap("1")
                                        },
                                      },
                                    },
                                    [
                                      _c("el-image", {
                                        staticClass: "image",
                                        attrs: {
                                          src: _vm.formValidate.image,
                                          "preview-src-list": _vm.isDisabled
                                            ? [_vm.formValidate.image]
                                            : [],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "upLoad",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap("1")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-camera cameraIconfont",
                                      }),
                                    ]
                                  ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：800*800px，上传小于500kb的图片")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品轮播图：",
                            prop: "sliderImages",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _vm._l(
                                _vm.formValidate.sliderImages,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "pictrue",
                                      attrs: { draggable: "true" },
                                      on: {
                                        dragstart: function ($event) {
                                          return _vm.handleDragStart(
                                            $event,
                                            item
                                          )
                                        },
                                        dragover: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleDragOver(
                                            $event,
                                            item
                                          )
                                        },
                                        dragenter: function ($event) {
                                          return _vm.handleDragEnter(
                                            $event,
                                            item
                                          )
                                        },
                                        dragend: function ($event) {
                                          return _vm.handleDragEnd($event, item)
                                        },
                                      },
                                    },
                                    [
                                      _c("el-image", {
                                        staticClass: "image",
                                        attrs: {
                                          src: item,
                                          "preview-src-list":
                                            _vm.formValidate.sliderImages,
                                        },
                                      }),
                                      !_vm.isDisabled
                                        ? _c("i", {
                                            staticClass: "el-icon-error btndel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemove(index)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm.formValidate.sliderImages.length < 10 &&
                              !_vm.isDisabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upLoadPicBox",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap("2")
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "保障服务：", prop: "guarantee" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: "请选择",
                                disabled: _vm.isDisabled,
                              },
                              on: { change: _vm.updateGuaranteeIds },
                              model: {
                                value: _vm.guaranteeIdsList,
                                callback: function ($$v) {
                                  _vm.guaranteeIdsList = $$v
                                },
                                expression: "guaranteeIdsList",
                              },
                            },
                            _vm._l(_vm.guaranteeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主图视频：" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width mr15",
                            attrs: {
                              maxlength: "250",
                              disabled: _vm.isDisabled,
                              placeholder: "请输入视频链接",
                            },
                            model: {
                              value: _vm.videoLink,
                              callback: function ($$v) {
                                _vm.videoLink = $$v
                              },
                              expression: "videoLink",
                            },
                          }),
                          _vm.videoLink
                            ? _c(
                                "el-button",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  on: { click: _vm.zh_uploadFile },
                                },
                                [_vm._v("确认添加")]
                              )
                            : _vm._e(),
                          !_vm.videoLink
                            ? _c(
                                "el-button",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap(
                                        "3",
                                        "",
                                        "",
                                        "video"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("选择视频")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _vm.formValidate.videoLink
                      ? _c("div", { staticClass: "iview-video-style" }, [
                          _c(
                            "video",
                            {
                              staticStyle: {
                                width: "100%",
                                height: "100% !important",
                                "border-radius": "10px",
                              },
                              attrs: {
                                src: _vm.formValidate.videoLink,
                                controls: "",
                                autoplay: "",
                                muted: "",
                              },
                              domProps: { muted: true },
                            },
                            [_vm._v(" 您的浏览器不支持 video 标签。 ")]
                          ),
                          _c("div", { staticClass: "mark" }),
                          _c("span", {
                            staticClass: "iconv iconfont iconmd-trash",
                            on: {
                              click: function ($event) {
                                return _vm.delVideo()
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运费模板：", prop: "tempId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width mr15",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.tempId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "tempId", $$v)
                                },
                                expression: "formValidate.tempId",
                              },
                            },
                            _vm._l(_vm.shippingList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "mr15",
                              on: { click: _vm.addTem },
                            },
                            [_vm._v("运费模板")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.currentTab == 1
                ? _c("creatAttr", {
                    attrs: {
                      oneFormBatch: _vm.oneFormBatch,
                      isDisabled: _vm.isDisabled,
                      formThead: _vm.formThead,
                      manyTabDate: _vm.manyTabDate,
                      OneattrValue: _vm.OneattrValue,
                      ManyAttrValue: _vm.ManyAttrValue,
                      manyTabTit: _vm.manyTabTit,
                    },
                    on: {
                      changeManyAttrValue: _vm.changeManyAttrValue,
                      handleBatchDel: _vm.handleBatchDel,
                    },
                    model: {
                      value: _vm.formValidate,
                      callback: function ($$v) {
                        _vm.formValidate = $$v
                      },
                      expression: "formValidate",
                    },
                  })
                : _vm._e(),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 2 && !_vm.isDisabled,
                      expression: "currentTab == 2 && !isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品详情：" } },
                        [
                          _c("Tinymce", {
                            key: _vm.htmlKey,
                            model: {
                              value: _vm.formValidate.content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "content",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 2 && _vm.isDisabled,
                      expression: "currentTab == 2 && isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品详情：" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.formValidate.content || "无"),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 3,
                      expression: "currentTab == 3",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序：" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  "controls-position": "right",
                                  min: 0,
                                  placeholder: "请输入排序",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "sort", $$v)
                                  },
                                  expression: "formValidate.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "积分：" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  "controls-position": "right",
                                  min: 0,
                                  placeholder: "请输入排序",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.giveIntegral,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "giveIntegral",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.giveIntegral",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "虚拟销量：" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  "controls-position": "right",
                                  min: 0,
                                  placeholder: "请输入排序",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.ficti,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "ficti", $$v)
                                  },
                                  expression: "formValidate.ficti",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品推荐：" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: {
                                size: "small",
                                disabled: _vm.isDisabled,
                              },
                              on: { change: _vm.onChangeGroup },
                              model: {
                                value: _vm.checkboxGroup,
                                callback: function ($$v) {
                                  _vm.checkboxGroup = $$v
                                },
                                expression: "checkboxGroup",
                              },
                            },
                            _vm._l(_vm.recommend, function (item, index) {
                              return _c(
                                "el-checkbox",
                                { key: index, attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "活动优先级：" } }, [
                        _c(
                          "div",
                          { staticClass: "color-list acea-row row-middle" },
                          [
                            _vm._l(_vm.formValidate.activity, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item,
                                  staticClass: "color-item",
                                  class: _vm.activity[item],
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    draggable: "true",
                                  },
                                  on: {
                                    dragstart: function ($event) {
                                      return _vm.handleDragStart($event, item)
                                    },
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                      return _vm.handleDragOver($event, item)
                                    },
                                    dragenter: function ($event) {
                                      return _vm.handleDragEnterFont(
                                        $event,
                                        item
                                      )
                                    },
                                    dragend: function ($event) {
                                      return _vm.handleDragEnd($event, item)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item) + " ")]
                              )
                            }),
                            _c("div", { staticClass: "tip" }, [
                              _vm._v("可拖动按钮调整活动的优先展示顺序"),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "proCoupon",
                          attrs: { label: "优惠券：" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm._l(
                                _vm.formValidate.coupons,
                                function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticClass: "mr10",
                                      attrs: {
                                        closable: !_vm.isDisabled,
                                        "disable-transitions": false,
                                      },
                                      on: {
                                        close: function ($event) {
                                          return _vm.handleCloseCoupon(tag)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(tag.name) + " ")]
                                  )
                                }
                              ),
                              _vm.formValidate.couponIds == null
                                ? _c("span", { staticClass: "mr10" }, [
                                    _vm._v("暂无优惠券"),
                                  ])
                                : _vm._e(),
                              !_vm.isDisabled
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "mr15",
                                      on: { click: _vm.addCoupon },
                                    },
                                    [_vm._v("选择优惠券")]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) > 0,
                          expression: "Number(currentTab) > 0",
                        },
                      ],
                      staticClass: "submission",
                      on: { click: _vm.handleSubmitUp },
                    },
                    [_vm._v("上一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < 3,
                          expression: "Number(currentTab) < 3",
                        },
                      ],
                      staticClass: "submission",
                      class: Number(_vm.currentTab) == 0 ? "onePrimary" : "",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$route.params.isDraft,
                          expression: "$route.params.isDraft",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("保存草稿")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CreatTemplates", {
        ref: "addTemplates",
        on: { getList: _vm.getShippingList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }